import React, { Fragment } from "react";
import { Route, Switch } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoute";
import { interceptor } from "utils/interceptor";
import HomeContainer from "containers/Home/homeContainer";
import CamDo from "containers/CamDo";
import TraGop from "containers/TraGop";
import NoPhaiThu from "containers/NoPhaiThu";
import { DongTienNhanh } from "components/DongTienNhanh";
import { NhanVay } from "components/NhanVay";
import DanhSachKhachHang from "containers/DanhSachKhachHang";
import CheckThongTinKh from "containers/CheckThongTinKh";
import TinChap from "containers/TinChap";
import KiemTraNoXau from "containers/KiemTraNoXau";
// import DanhSachCuaHang from "containers/DanhSachCuaHang";
import TongQuatCuaHang from "components/QuanLyDaCuaHang/TongQuatCuaHang";
//import ChiTietCuaHang from "containers/ChiTietCuaHang";
import DanhSachTaiSan from "containers/DanhSachTaiSan";
import DanhSachKho from "containers/DanhSachKho";
import CongNoThanhLy from "containers/CongNoThanhLy";
import DanhSachThanhLy from "containers/DanhSachThanhLy";
import DanhSachKiemKho from "containers/DanhSachKiemKho";
import KiemKho from "containers/KiemKho";
import Ticket from "containers/Ticket";
import { DanhGia } from "components/Ticket/ChucNang/DanhGia";
import DanhSachNhanVien from "containers/DanhSachNhanVien";
import QuanLyCongViec from "containers/QuanLyCongViec";
import TrangChu from "containers/TrangChu";
import DuNoNhanVay from "containers/DuNoNhanVay";
import DuNoChoVay from "containers/DuNoChoVay";
import DuNoGiaoNhanVien from "containers/DuNoGiaoNhanVien";
import DanhSachHopDongBiXoa from "containers/DanhSachHopDongBiXoa";
import DanhSachChiBiXoa from "containers/DanhSachChiBiXoa";
import DanhSachThuBiXoa from "containers/DanhSachThuBiXoa";
import HopDongChoDuyet from "containers/DanhSachHopDongChoDuyet";
import { HopDongChoDuyetPheDuyet } from "components/BaoCao/HopDongChoDuyetPheDuyet";
import QuanLyThuChiHopDong from "containers/QuanLyThuChiHopDong";
import QuanLyThuChiNgoaiLe from "containers/QuanLyThuChiNgoaiLe";
import XuatHoaDon from "components/QuanLyThuChi/XuatHoaDon";
import NguonVon from "containers/NguonVon";
import { DanhSachVay } from "components/ChoThongTin/DanhSachVay";
import { DanhSachDaMua } from "components/ChoThongTin/DanhSachDaMua";
import { PageThankYou } from "components/CommonComponent/PageThankYou";
import { PageError } from "components/ThongBaoKhiDangNhap/pageError";
import { BaoCaoChiNhanh } from "components/TongChiNhanh/BaoCaoChiNhanh";
import { BaoCaoTongQuan } from "components/TongChiNhanh/BaoCaoTongQuan";
import TwoFactor from "components/TwoFactor";
import TwoFactorVerify from "components/TwoFactor/verify";
import BanHangTraGop from "containers/BanHangTraGop";
import { CauHinhGoiTraGop } from "components/QuanTriHeThong/CauHinhGoiTraGop";
import { DanhSachBank } from "components/TichHopBank/DanhSachBank";
import { LichSuGiaoDich } from "components/TichHopBank/LichSuGiaoDich";
// import { ThoaThuanSuDung } from "components/QuanTriHeThong/ThoaThuanSuDung";
import { DanhSachChoThanhToan } from "components/TichHopBank/DanhSachChoThanhToan";
import { DanhSachHopDongKySo } from "components/DanhSachHopDongKySo";
import { DanhSachGoiVay } from "components/GoiVay/DanhSachGoiVay";
import { DanhSachCapPheDuyet } from "components/QuyTrinhPheDuyet/DanhSachCapPheDuyet";
import { PhanQuyenTaoChoDuyet } from "components/QuyTrinhPheDuyet/PhanQuyenTaoChoDuyet";
import { TatToanChoDuyet } from "components/BaoCao/TatToanChoDuyet";
import { TaiKhoanIcloud } from "components/QuanTriHeThong/TaiKhoanIcloud";
import TinChapNoXau from "containers/DanhSachNoXau/TinChap";
import TraGopNoXau from "containers/DanhSachNoXau/TraGop";
import CamDoNoXau from "containers/DanhSachNoXau/CamDo";
import { LoaiPhieuThuChi } from "components/QuanTriHeThong/LoaiPhieuThuChi";
import { KiemKe } from "components/BaoCao/KiemKe";
import { QuanLyMauHopDong } from "components/QuanTriHeThong/QuanLyMauHopDong";
import DanhSachLog from "components/QuanTriHeThong/QuanLyLog";
import DanhSachMauThuChi from "components/QuanTriHeThong/QuanLyMauThuChi";
import DanhSachQuyKhac from "components/QuanLyQuyKhac";
import DanhSachCuaHang from "components/QuanLyDaCuaHang/DanhSachCuaHang";
import ChiTietCuaHang from "components/QuanLyDaCuaHang/ChiTietCuaHang";
import CauHinhTaiSan from "components/QuanTriHeThong/CauHinhTaiSan";
import CauHinhThongKeKhachHang from "components/QuanTriHeThong/CauHinhThongKeKhachHang";
import ThuocTinhGiamTru from "components/QuanTriHeThong/ThuocTinhGiamTru";
import ThongTinDangNhap from "components/ThongTinDangNhap";
import { CauHinhTinhLai } from "components/QuanTriHeThong/CauHinhTinhLai";
import { CauHinhHeThong } from "components/QuanTriHeThong/CauHinhHeThong";
import { ThongKeThu } from "components/ThongKe/ThongKeThu";
import { ThongKeChi } from "components/ThongKe/ThongKeChi";
import { ThongKeThuDuKien } from "components/ThongKe/ThongKeThuDuKien";
import GiaoDichChoDuyet from "components/BaoCao/GiaoDichChoDuyet";
import { QuanLiCongViec } from "components/QuanLyNhanVien/QuanLyCongViec";
import DanhSachTatToan from "components/BaoCao/DanhSachTatToan";
import { GiaoDichTrongNgay } from "components/BaoCao/GiaoDichTrongNgay";
import { DanhSachKhachHang1 } from "components/QuanLyKhachHang/DanhSachKhachHang";
import RegisterForm from "components/Auth";
import DanhSachNhapHang from "components/QuanLyMuaBan/NhapHang";
import DanhSachBanHang from "components/QuanLyMuaBan/BanHang";
import DanhSachLoiNhuanBanHang from "components/QuanLyMuaBan/LoiNhuanBanHang";

import { LoginForm } from "components/Auth/DangNhap";
import { QuenMatKhau } from "components/Auth/QuenMatKhau";
import { KhoiPhucMatKhau } from "components/Auth/KhoiPhucMatKhau";
import CongNoBanHang from "components/QuanLyMuaBan/CongNoBanHang";
import QuyTienMat from "components/BaoCao/DongTien";
import { ThongKeLoiNhuan } from "components/BaoCao/LoiNhuan";
import { ThongKeKhachHangGiaTang } from "components/BaoCao/KhachHangGiaTang";
import { DanhSachTrichLapDuPhong } from "components/DanhSachTrichLapDuPhong";
import { TaiSanCongTy } from "components/TaiSanCongTy";
import { KiemTraKySo } from "components/DanhSachHopDongKySo/KiemTraKySo/KiemTraKySo";
import { ThoaThuanSuDung } from "components/QuanTriHeThong/ThoaThuanSuDung";
import { KhongCoQuyenTruyCap } from "components/KhongCoQuyenTruyCap";
export default function App() {
  return (
    <Fragment>
      <Switch>
        <Route exact path="/dang-nhap.aspx" component={LoginForm} />
        <Route exact path="/dang-ky-dung-thu.aspx" component={RegisterForm} />
        <Route exact path="/quen-mat-khau.aspx" component={QuenMatKhau} />
        <Route
          exact
          path="/khoi-phuc-mat-khau.aspx"
          component={KhoiPhucMatKhau}
        />
        <Route exact path="/two-factor" component={TwoFactor} />
        <Route exact path="/two-factor/verify" component={TwoFactorVerify} />
        <Route exact path="/" component={LoginForm} />

        <ProtectedRoute exact path="/" component={HomeContainer} />
        <ProtectedRoute
          exact
          path="/trang-chu/khong-co-quyen-truy-cap.aspx"
          component={KhongCoQuyenTruyCap}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/loi-nhuan.aspx"
          component={ThongKeLoiNhuan}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/khach-hang-gia-tang.aspx"
          component={ThongKeKhachHangGiaTang}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/dong-tien.aspx"
          component={QuyTienMat}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-mua-ban/mua-hang.aspx"
          component={DanhSachNhapHang}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-mua-ban/cong-no-ban-hang.aspx"
          component={CongNoBanHang}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-mua-ban/ban-hang.aspx"
          component={DanhSachBanHang}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-mua-ban/loi-nhuan-ban-hang.aspx"
          component={DanhSachLoiNhuanBanHang}
        />

        <ProtectedRoute
          exact
          path="/tong-chi-nhanh/bao-cao-tong-quan.aspx"
          component={BaoCaoTongQuan}
        />
        <ProtectedRoute
          exact
          path="/tong-chi-nhanh/thong-ke-cua-hang.aspx"
          component={BaoCaoChiNhanh}
        />

        <ProtectedRoute exact path="/trang-chu.aspx" component={TrangChu} />
        <ProtectedRoute exact path="/trang-chu/cam-do.aspx" component={CamDo} />
        <ProtectedRoute
          exact
          path="/trang-chu/tin-chap.aspx"
          component={TinChap}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/tra-gop.aspx"
          component={TraGop}
        />

        <ProtectedRoute
          exact
          path="/trang-chu/danh-sach-no-xau/cam-do.aspx"
          component={CamDoNoXau}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/danh-sach-no-xau/tin-chap.aspx"
          component={TinChapNoXau}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/danh-sach-no-xau/tra-gop.aspx"
          component={TraGopNoXau}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/kiem-ke-quy.aspx"
          component={KiemKe}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/giao-dich-trong-ngay.aspx"
          component={GiaoDichTrongNgay}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-he-thong/cau-hinh-tinh-lai.aspx"
          component={CauHinhTinhLai}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-he-thong/cau-hinh-he-thong.aspx"
          component={CauHinhHeThong}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-he-thong/thoa-thuan-su-dung.aspx"
          component={ThoaThuanSuDung}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/thong-ke/thong-ke-thu.aspx"
          component={ThongKeThu}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/thong-ke/thong-ke-chi.aspx"
          component={ThongKeChi}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/thong-ke/thong-ke-thu-du-kien.aspx"
          component={ThongKeThuDuKien}
        />

        <ProtectedRoute
          exact
          path="/trang-chu/no-phai-thu.aspx"
          component={NoPhaiThu}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/dong-tien-nhanh.aspx"
          component={DongTienNhanh}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-nguon-von/nhan-vay.aspx"
          component={NhanVay}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-khach-hang/danh-sach-khach-hang1.aspx"
          component={DanhSachKhachHang1}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-khach-hang/danh-sach-khach-hang.aspx"
          component={DanhSachKhachHang}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-khach-hang/check-thong-tin-khach-hang.aspx"
          component={CheckThongTinKh}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-khach-hang/check-no-xau.aspx"
          component={KiemTraNoXau}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-cua-hang/danh-sach-cua-hang.aspx"
          component={DanhSachCuaHang}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-da-cua-hang/tong-quat-cua-hang.aspx"
          component={TongQuatCuaHang}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-da-cua-hang/chi-tiet-cua-hang.aspx"
          component={ChiTietCuaHang}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-tai-san/danh-sach-tai-san.aspx"
          component={DanhSachTaiSan}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-tai-san/danh-sach-kho.aspx"
          component={DanhSachKho}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-tai-san/cong-no-thanh-ly.aspx"
          component={CongNoThanhLy}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-tai-san/danh-sach-thanh-ly.aspx"
          component={DanhSachThanhLy}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-thu-chi/trich-lap-du-phong.aspx"
          component={DanhSachTrichLapDuPhong}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-tai-san/danh-sach-tai-san-cong-ty.aspx"
          component={TaiSanCongTy}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-tai-san/kiem-kho.aspx"
          component={KiemKho}
        />
        <ProtectedRoute exact path="/ticket/danhsach.aspx" component={Ticket} />
        <ProtectedRoute exact path="/ticket/danhgia.aspx" component={DanhGia} />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-tai-san/danh-sach-kiem-kho.aspx"
          component={DanhSachKiemKho}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-nhan-vien/danh-sach-nhan-vien.aspx"
          component={DanhSachNhanVien}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-nhan-vien/quan-ly-cong-viec.aspx"
          component={QuanLyCongViec}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-li-nhan-vien/quan-ly-cong-viec.aspx"
          component={QuanLiCongViec}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/du-no-nhan-vay.aspx"
          component={DuNoNhanVay}
        />

        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/du-no-cho-vay.aspx"
          component={DuNoChoVay}
        />

        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/du-no-giao-nhan-vien.aspx"
          component={DuNoGiaoNhanVien}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/thong-ke/danh-sach-hop-dong-bi-xoa.aspx"
          component={DanhSachHopDongBiXoa}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/thong-ke/danh-sach-chi-bi-xoa.aspx"
          component={DanhSachChiBiXoa}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/thong-ke/danh-sach-thu-bi-xoa.aspx"
          component={DanhSachThuBiXoa}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/hop-dong-cho-duyet.aspx"
          component={HopDongChoDuyet}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/hop-dong-cho-duyet_phe_duyet.aspx"
          component={HopDongChoDuyetPheDuyet}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-thu-chi/thu-chi-hop-dong.aspx"
          component={QuanLyThuChiHopDong}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-thu-chi/thu-chi-ngoai-le.aspx"
          component={QuanLyThuChiNgoaiLe}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-thu-chi/xuat-hoa-don.aspx"
          component={XuatHoaDon}
        />

        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-nguon-von/nguon-von.aspx"
          component={NguonVon}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-he-thong/loai-phieu-thu-chi.aspx"
          component={LoaiPhieuThuChi}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-he-thong/quan-ly-mau-hop-dong.aspx"
          component={QuanLyMauHopDong}
        />
        <ProtectedRoute
          exact
          path="/cho-thong-tin/danh-sach-vay.aspx"
          component={DanhSachVay}
        />
        <ProtectedRoute
          exact
          path="/cho-thong-tin/danh-sach-da-mua.aspx"
          component={DanhSachDaMua}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/Thank-You.aspx"
          component={PageThankYou}
        />

        <ProtectedRoute
          exact
          path="/trang-chu/Page-Error.aspx"
          component={PageError}
        />

        <ProtectedRoute
          exact
          path="/trang-chu/ban-hang-tra-gop.aspx"
          component={BanHangTraGop}
        />

        <ProtectedRoute
          exact
          path="/trang-chu/cau-hinh-ban-hang-tra-gop.aspx"
          component={CauHinhGoiTraGop}
        />
        <ProtectedRoute
          exact
          path="/bank/danhsach.aspx"
          component={DanhSachBank}
        />
        <ProtectedRoute
          exact
          path="/bank/lichsugiaodich.aspx"
          component={LichSuGiaoDich}
        />
        <ProtectedRoute
          exact
          path="/bank/danhsachchothanhtoan.aspx"
          component={DanhSachChoThanhToan}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-ky-so/danh-sach-hop-dong-ky-so.aspx"
          component={DanhSachHopDongKySo}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-ky-so/kiem-tra-ky-so.aspx"
          component={KiemTraKySo}
        />
        <ProtectedRoute
          exact
          path="/quan-ly-he-thong/quan-ly-goi-vay.aspx"
          component={DanhSachGoiVay}
        />
        <ProtectedRoute
          exact
          path="/pheduyet/phan-quyen-duyet.aspx"
          component={DanhSachCapPheDuyet}
        />
        <ProtectedRoute
          exact
          path="/pheduyet/phan-quyen-tao-duyet.aspx"
          component={PhanQuyenTaoChoDuyet}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/tat-toan-cho-duyet.aspx"
          component={TatToanChoDuyet}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-tai-san/tai-khoan-icloud.aspx"
          component={TaiKhoanIcloud}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-tri-he-thong/quan-ly-log.aspx"
          component={DanhSachLog}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-he-thong/quan-ly-mau-thu-chi.aspx"
          component={DanhSachMauThuChi}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quy-khac.aspx"
          component={DanhSachQuyKhac}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-tri-he-thong/cau-hinh-tai-san.aspx"
          component={CauHinhTaiSan}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-tri-he-thong/cau-hinh-thong-ke-khach-hang.aspx"
          component={CauHinhThongKeKhachHang}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/quan-ly-he-thong/thuoc-tinh-giam-tru.aspx"
          component={ThuocTinhGiamTru}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/thong-tin-dang-nhap.aspx"
          component={ThongTinDangNhap}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/giao-dich-cho-duyet.aspx"
          component={GiaoDichChoDuyet}
        />
        <ProtectedRoute
          exact
          path="/trang-chu/bao-cao/danh-sach-tat-toan.aspx"
          component={DanhSachTatToan}
        />
      </Switch>
    </Fragment>
  );
}
